import React, { useEffect, useMemo } from 'react'
import Media from 'react-media'
import { Route, Switch } from 'react-router-dom'
import config from './config'
import EntrancePages from './containers/EntrancePages'
import PrivateRoute from './containers/PrivateRoute'

import MobileAuditorium from './mobileOnlyPages/MobileAuditorium/index.js'
import MobileExpoBooth from './mobileOnlyPages/MobileExpo/MobileExpoBooth.js'
import MobileExpoDirectory from './mobileOnlyPages/MobileExpo/MobileExpoDirectory.js'
import MobileLobby from './mobileOnlyPages/MobileLobby/index.js'
import MobileMenu from './mobileOnlyPages/MobileMenu/index.js'
import MobileNetworking from './mobileOnlyPages/MobileNetworking/index.js'
import MobileNotifications from './mobileOnlyPages/MobileNotifications/index.js'
import { MobileOnDemand } from './mobileOnlyPages/MobileOnDemand/'

import ActiveUserCountPage from './pages/ActiveUserCountPage'
import CountdownPage from './pages/CountdownPage'
import PostRegisterPage from './pages/registration/PostRegisterPage'
import PreRegisterPage from './pages/registration/PreRegisterPage'
import RegisterFormPage from './pages/registration/RegisterFormPage'
import SetPasswordFormPage from './pages/registration/SetPasswordFormPage'
import UserSessionPage from './pages/UserSessionPage'

import routes from './routes'
import { SIZES } from './styles/theme'

import AuditoriumPage from './webOnlyPages/AuditoriumPage'
import BoothPage from './webOnlyPages/Booth/BoothPage'
import ExhibitionPage from './webOnlyPages/ExhibitionPage'
import LobbyPage from './webOnlyPages/LobbyPage'
import NetworkingLoungePage from './webOnlyPages/NetworkingLoungePage'
import { DesktopOnDemand } from './webOnlyPages/DesktopOnDemand/'

function App() {
  useEffect(() => {
    document.title = config.eventName
  }, [])

  // useEffect(() => {
  //   window.chaport.q('hideLauncher')
  // }, [])

  return useMemo(() => {
    return (
      <>
        {/* Registration */}
        <Switch>
          <Route exact path={routes.preRegister} component={PreRegisterPage} />
          <Route exact path={routes.register} component={RegisterFormPage} />
          <Route exact path={routes.postRegister} component={PostRegisterPage} />
          <Route exact path={routes.root} component={EntrancePages} />

          <Route exact path={routes.resetPassword} component={SetPasswordFormPage} />
          <Route exact path="/realtime" component={ActiveUserCountPage} />
          <Route exact path="/sessions" component={UserSessionPage} />
          <Route exact path={routes.login} component={EntrancePages} />
        </Switch>

        <Media query={`(max-width: ${SIZES.mobileBreakpoint})`}>
          {(matches) =>
            matches ? (
              // MOBILE ROUTES
              <Switch>
                <PrivateRoute path={routes.lobby} component={MobileLobby} mobileNav />

                {/* Auditorium */}
                <PrivateRoute
                  mobileNav
                  path={routes.auditorium1}
                  component={(props) => <MobileAuditorium {...props} hallNumber={1} liveUrl="https://vimeo.com/event/1260788/embed" />}
                />
                <PrivateRoute mobileNav path={routes.auditorium2} component={(props) => <MobileAuditorium {...props} hallNumber={2} liveUrl="" />} />
                <PrivateRoute mobileNav path={routes.auditorium3} component={(props) => <MobileAuditorium {...props} hallNumber={3} liveUrl="" />} />
                <PrivateRoute mobileNav path={routes.auditorium4} component={(props) => <MobileAuditorium {...props} hallNumber={4} liveUrl="" />} />
                <PrivateRoute mobileNav path={routes.auditorium5} component={(props) => <MobileAuditorium {...props} hallNumber={5} liveUrl="" />} />

                <PrivateRoute path={routes.networking} component={MobileNetworking} mobileNav />
                <PrivateRoute path="/exhibition-hall/:hallId" component={MobileExpoDirectory} mobileNav />
                <PrivateRoute path="/booths/:boothId" component={MobileExpoBooth} mobileNav />
                <PrivateRoute path="/menu" component={MobileMenu} mobileNav />
                <PrivateRoute path={routes.notifications} component={MobileNotifications} mobileNav />
                <PrivateRoute path={routes.onDemand} component={MobileOnDemand} mobileNav />
              </Switch>
            ) : (
              // DESKTOP ROUTES
              <Switch>
                <PrivateRoute path={routes.lobby} component={LobbyPage} fixedNav />
                <PrivateRoute path={routes.networking} component={NetworkingLoungePage} fixedNav />

                {/* Auditorium */}
                {/* Main Hall */}
                <PrivateRoute
                  fixedNav
                  path={routes.auditorium1}
                  component={(props) => <AuditoriumPage {...props} hallNumber={1} liveUrl="https://vimeo.com/event/1260788/embed" />}
                />
                {/* Concurrent 1 */}
                <PrivateRoute fixedNav path={routes.auditorium2} component={(props) => <AuditoriumPage {...props} hallNumber={2} liveUrl="" />} />
                {/* Concurrent 2 */}
                <PrivateRoute fixedNav path={routes.auditorium3} component={(props) => <AuditoriumPage {...props} hallNumber={3} liveUrl="" />} />
                {/* Concurrent 3 */}
                <PrivateRoute fixedNav path={routes.auditorium4} component={(props) => <AuditoriumPage {...props} hallNumber={4} liveUrl="" />} />
                {/* Knowledge Sharing Lounge */}
                <PrivateRoute fixedNav path={routes.auditorium5} component={(props) => <AuditoriumPage {...props} hallNumber={5} liveUrl="" />} />

                <PrivateRoute path="/exhibition-hall/:hallId" component={ExhibitionPage} fixedNav />
                <PrivateRoute path={routes.onDemand} component={DesktopOnDemand} fixedNav />
                <PrivateRoute path="/booths/:boothId" component={BoothPage} fixedNav />
              </Switch>
            )
          }
        </Media>
      </>
    )
  }, [])
}

export default App
